import React from 'react';
export class BaseTrack extends React.Component {
  constructor(props) {
    super(props);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.node = null;
    this.trackDragEvent = null;
  }
  getClientRect() {
    var _this$node;
    return (_this$node = this.node) === null || _this$node === void 0 ? void 0 : _this$node.getBoundingClientRect();
  }
  getActiveTrackStyle() {
    const width = `${(this.props.percentages.max - this.props.percentages.min) * 100}%`;
    const left = `${this.props.percentages.min * 100}%`;
    return {
      left,
      width
    };
  }
  addDocumentMouseMoveListener() {
    this.removeDocumentMouseMoveListener();
    if (this.node) this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
  }
  addDocumentMouseUpListener() {
    this.removeDocumentMouseUpListener();
    if (this.node) this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
  }
  removeDocumentMouseMoveListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
  }
  removeDocumentMouseUpListener() {
    if (this.node) this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
  }
  handleMouseMove(event) {
    if (!this.props.draggableTrack) {
      return;
    }
    if (this.trackDragEvent !== null) {
      this.props.onTrackDrag(event, this.trackDragEvent);
    }
    this.trackDragEvent = event;
  }
  handleMouseUp() {
    if (!this.props.draggableTrack) {
      return;
    }
    this.removeDocumentMouseMoveListener();
    this.removeDocumentMouseUpListener();
    this.trackDragEvent = null;
  }
  handleMouseDown(event) {
    const e = event;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const trackClientRect = this.getClientRect();
    const position = {
      x: clientX - trackClientRect.left,
      y: 0
    };
    this.props.onTrackMouseDown(event, position);
    if (this.props.draggableTrack) {
      this.addDocumentMouseMoveListener();
      this.addDocumentMouseUpListener();
    }
  }
  handleTouchStart(event) {
    event.preventDefault();
    this.handleMouseDown(event);
  }
  render() {
    const activeTrackStyle = this.getActiveTrackStyle();
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.classNames.track,
      onMouseDown: this.handleMouseDown,
      onTouchStart: this.handleTouchStart,
      ref: node => {
        this.node = node;
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: activeTrackStyle,
      className: this.props.classNames.activeTrack
    }), this.props.children);
  }
}